import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { MODES } from '../../../../utils/constant';
import { getTempModeIcon } from '../util';
import { useMobileStyles } from '../styles';
import Icon from '../../../../utils/icons';
import I18n from '../../../../localization';

const AirModeSelector = ({  availableModes,  iqAirDetails,  onModeChange,  isDarkMode,  iqAirId  }) => {
  const classes = useMobileStyles();

  return (
    <Box className={[classes.IQCard, classes.IQAirMode, classes.InnerCards].join(" ")}>
      <Typography className={classes.cardInnerLabel}>{I18n.t("mobile.iqAirSetting.iqAirDeviceMode")}</Typography>

      <Box className={classes.modeCard}>
        {availableModes && availableModes.map((airMode) => {
          const isModeSelected = iqAirDetails.airMode === airMode;
          return (
            <Box
              onClick={() => onModeChange(airMode)}
              className={[
                classes.iconLayout,
                isModeSelected ? classes.selected : "",
                classes.addPointer,
                `${isDarkMode && 'tempMode-' + airMode}`
              ].join(" ")}
              key={airMode}
            >
              <Icon
                src={getTempModeIcon(isModeSelected, airMode, isDarkMode)}
                className={isModeSelected ? 'selectedMode' : ''}
                id={iqAirId}
              />
            </Box>
          );
        })}
      </Box>
      
      <Box className={[classes.modeCard, classes.modeText].join(" ")} style={{marginTop:'-16px'}}>
        {availableModes && availableModes.map((airMode) => {
          return (
            <Typography className={classes.iconLayout} key={airMode}>
              {airMode.charAt(0) + airMode.slice(1).toLowerCase()}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
};

export default AirModeSelector;
